import { useState, useEffect, useRef, RefObject } from 'react';

import { TabPanel, TabView } from 'primereact/tabview';
import FrontEndParameter from '../../components/params/front-end';
import MiddleLayerParameter from 'components/params/middle_layer_1';
import { addParamsConfig, getClientByVersion, getClientInfo, getClientVersions } from 'services/paramsConfigService';
import { useForm, FormProvider } from 'react-hook-form';
import { ToastContent, toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { handleLoader } from 'redux/counterSlice';
import ParamsPopUp from '../../components/params/Params-Info-popup';
import BackendLayer from 'components/params/backend';
import { Dropdown } from "primereact/dropdown";
import * as myConst from "../../constants/index"
import { onerror } from 'q';
import ChatBotParams from 'components/params/chatbot-params';
import VoiceParamsLayer from 'components/params/voice-params';
import GenerationParams from 'components/params/generation-params';
import CryptoJS from 'crypto-js';
import ButterPieParams from 'components/params/butter-pie-params';



function AddUpdateConfiguration({
    fieldData,
    setFieldData,
    getFieldData,
    clientVersion,
    setClientVersion,
    getFieldDataByVersion
}: any) {
    const location = useLocation()
    const dispatch = useDispatch();

    const secretKey = 'RON__USER__LOGIN';
    const iv = 'BBBBBBBBBBBBBBBB';
    // Function to encrypt the password
    const encryptPassword = (password: string) => {
        const encrypted = CryptoJS.AES.encrypt(password, CryptoJS.enc.Utf8.parse(secretKey), {
            iv: CryptoJS.enc.Utf8.parse(iv),
            mode: CryptoJS.mode.ECB
        });
        return encrypted.toString();
    };
    // Function to decrypt the password
    const decryptPassword = (encryptedPassword: string) => {
        try {
            const parsedKey = CryptoJS.enc.Utf8.parse(secretKey);

            // Decrypt using AES with ECB mode
            const decrypted = CryptoJS.AES.decrypt(encryptedPassword, parsedKey, {
                mode: CryptoJS.mode.ECB
            });
            // Convert decrypted data to UTF-8 string
            return decrypted.toString(CryptoJS.enc.Utf8);
        } catch (error) {
            console.error('Error decrypting data:', error);
            return '';
        }
    };

    const generateDefaultValues = (fieldData: any) => {
        // Define your logic here to generate default values based on fieldData
        return {
            client_name: fieldData?.client_name,
            default_label: fieldData?.default_label,
            default_questions: fieldData?.default_questions,
            // logos_urls.logo_side_img : fieldData.logos_urls.logo_side_img,
            // logos_urls.logo_home_page : fieldData.logos_urls.logo_home_page,
            keycloak_credentials: {
                client_id: fieldData?.keycloak_credentials?.client_id,
                client_secret: fieldData?.keycloak_credentials?.client_secret,
                realm_name: fieldData?.keycloak_credentials?.realm_name,
                base_url: fieldData?.keycloak_credentials?.base_url
            },
            mongodb_credentials: {
                connection_name: fieldData?.mongodb_credentials?.connection_name,
                host_port: fieldData?.mongodb_credentials?.host_port,
                user_name: fieldData?.mongodb_credentials?.user_name,
                password: fieldData?.mongodb_credentials?.password,
                db_name: fieldData?.mongodb_credentials?.db_name,
            },
            postgres_credentials: {
                host_port: fieldData?.postgres_credentials?.host_port,
                user_name: fieldData?.postgres_credentials?.user_name,
                password: fieldData?.postgres_credentials?.password,
                db_name: fieldData?.postgres_credentials?.db_name
            },
            ai_ml_api: {
                base_url_ron: fieldData?.ai_ml_apis?.base_url_ron,
                base_url_gpt: fieldData?.ai_ml_apis?.base_url_gpt,
                base_url_file_processing: fieldData?.ai_ml_apis?.base_url_file_processing
            },
            email_configuration: {
                smtp_server: fieldData?.email_configurations?.smtp_server,
                smtp_port: fieldData?.email_configurations?.smtp_port,
                smtp_username: fieldData?.email_configurations?.smtp_username,
                smtp_password: fieldData?.email_configurations?.smtp_password
            },
            voice_params: {
                max_new_tokens: { name: fieldData?.voice_params?.max_new_tokens },
                chunk_length_s: { name: fieldData?.voice_params?.chunk_length_s },
                batch_size: { name: fieldData?.voice_params?.batch_size }
            },
            lama_model_conf: {
                // n_gpu_layers: parseInt(fieldData?.lama_model_conf?.n_gpu_layers),
                // n_batch: parseInt(fieldData?.lama_model_conf?.n_batch),
                max_token: { name: fieldData?.lama_model_conf?.max_token },
                temperature: fieldData?.lama_model_conf?.temperature,
                // n_ctx: parseInt(fieldData?.lama_model_conf?.n_ctx),
                streaming: fieldData?.lama_model_conf?.streaming === true ? { name: "True" } : fieldData?.lama_model_conf?.streaming === false ? { name: "False" } : "",
            },
            RON_lama_system_prompt: {
                default_system_prompt: fieldData?.RON_lama_system_prompt?.default_system_prompt,
                prompt_document_training: fieldData?.RON_lama_system_prompt?.prompt_document_training,
                prompttemplatetextsummerization: fieldData?.RON_lama_system_prompt?.prompttemplatetextsummerization,
                ner_prompt: fieldData?.RON_lama_system_prompt?.ner_prompt,
                prompttemplateclassification: fieldData?.RON_lama_system_prompt?.prompttemplateclassification,
            },
            generation_param: {
                inference_server_url: fieldData?.generation_param.inference_server_url,
                max_new_tokens: { name: fieldData?.generation_param?.max_new_tokens },
                temperature: fieldData?.generation_param.temperature,
                default_email_template: fieldData?.generation_param.default_email_template,
                default_post_template: fieldData?.generation_param.default_post_template,
                default_product_template: fieldData?.generation_param.default_product_template,
                default_regenerate_product_template: fieldData?.generation_param.default_regenerate_product_template,
                default_article_template: fieldData?.generation_param.default_article_template,
                default_idea_template: fieldData?.generation_param.default_idea_template
            },
            butter_pie_configuration: {
                content_strategy: fieldData?.butter_pie_configuration.content_strategy,
                content_production: fieldData?.butter_pie_configuration.content_production,
                audience_growth: fieldData?.butter_pie_configuration.audience_growth,
                monetization: fieldData?.butter_pie_configuration.monetization,
                marketing_seo: fieldData?.butter_pie_configuration.marketing_seo,
                legal_ethical: fieldData?.butter_pie_configuration.legal_ethical,
                mindset_productivity: fieldData?.butter_pie_configuration.mindset_productivity,
                networking: fieldData?.butter_pie_configuration.networking,
                general_prompt: fieldData?.butter_pie_configuration.general_prompt,
                api_key: encryptPassword(fieldData?.butter_pie_configuration.api_key),
            },
            pdf_documents: {
                chunk_size: { name: fieldData?.pdf_documents?.chunk_size },
                chunk_overlap: { name: fieldData?.pdf_documents?.chunk_overlap },
            },
            lama_model_name: {
                model_name_or_path: fieldData?.lama_model_name?.model_name_or_path,
                // model_basename: fieldData?.lama_model_name?.model_basename,
            },
            embedding_model_name: {
                embedding_model_name: fieldData?.embedding_model_name?.embedding_model_name,
            },
            faiss_vactor_db: {
                ron_main_vector_db_directory: fieldData?.faiss_vactor_db?.ron_main_vector_db_directory,
                user_temp_folder: fieldData?.faiss_vactor_db.user_temp_folder,
                source_info_threshold: fieldData?.faiss_vactor_db?.source_info_threshold
            },
            actual_pdf: {
                actual_pdf_base_url: fieldData?.actual_pdf?.actual_pdf_base_url,
            },

            ai_chatbot: {
                temperature: fieldData?.ai_chatbot?.temperature,
                max_token: { name: fieldData?.ai_chatbot?.max_token },
                log_url: fieldData?.ai_chatbot?.log_url,
                main_category: fieldData?.ai_chatbot?.main_category,
                bundling_on_column_name: fieldData?.ai_chatbot?.bundling_on_column_name,
                category_style_idea: fieldData?.ai_chatbot?.category_style_idea?.join(","),
                max_pdf_size: { name: fieldData?.ai_chatbot?.max_pdf_size },
                max_zip_size: { name: fieldData?.ai_chatbot?.max_zip_size },
                primary_column: fieldData?.ai_chatbot?.primary_column,
                product_details: fieldData?.ai_chatbot?.product_details,
                sub_category: fieldData?.ai_chatbot?.sub_category,
                source_name: fieldData?.ai_chatbot?.source_name,
                // system_prompt: fieldData?.ai_chatbot?.system_prompt
            },
            TGI_llama_inference_url: {
                inference_server_url_local: fieldData.TGI_llama_inference_url.inference_server_url_local
            },


            Metadata: {
                version: fieldData?.Metadata?.version,
            },
            log_source: { name: fieldData?.log_source },
            file_size: fieldData?.file_size,
        };
    };

    const form = useForm({ mode: "all", defaultValues: generateDefaultValues(fieldData) });

    const [questions, setQuestions] = useState<string[]>([]);
    const [inputFile1, setInputFile1] = useState<string>("");
    const [inputFile2, setInputFile2] = useState<string>("");
    const [inputFile1Base, setInputFile1Base] = useState<string>("");
    const [inputFile2Base, setInputFile2Base] = useState<string>("");
    const [versionOptions, setVersionOptions] = useState<string[]>([]);
    const [isBackendDataChanged, setIsBackendDataChanged] = useState(false)
    const [isVoiceDataChanged, setIsVoiceDataChanged] = useState(false)
    const [isChatBotDataChanged, setIsChatBotDataChanged] = useState(false)
    const [isGenerationDataChanged, setIsGenerationChanged] = useState(false)
    const [isButterPieChanged, setIsButterPieChanged] = useState(false)
    const [textValue, setTextValue] = useState(""); // Initial value
    const [systemProm, setSystemProm] = useState(fieldData?.RON_lama_system_prompt?.default_system_prompt);

    const queryParams = new URLSearchParams(location.search);
    const envParam = queryParams.get('env');


    const handelPrompt = (data: any) => {
        setSystemProm(data)
    }

    useEffect(() => {
        // Check if form is dirty before resetting
        if (fieldData) {
            const newDefaultValues = generateDefaultValues(fieldData);
            form.reset(newDefaultValues);
        }
    }, [fieldData]);


    useEffect(() => {
        const nonEmptyQuestions = fieldData && fieldData.default_questions
            ? fieldData.default_questions.filter((question: string) => question.trim() !== "")
            : [];

        setQuestions(nonEmptyQuestions);

        // setQuestions(fieldData && fieldData.default_questions)
        setInputFile1Base(fieldData && fieldData.logos_urls.logo_home_page)
        setInputFile2Base(fieldData && fieldData.logos_urls.logo_side_img)
    }, [fieldData])

    // const getFieldData = async (env: any) => {
    //     dispatch(handleLoader(true));
    //     try {
    //         const { result, error } = await getClientInfo(env);
    //         if (error) {
    //             throw error
    //         }
    //         if (result?.error) {
    //             throw result.error
    //         }
    //         setFieldData(result)
    //         dispatch(handleLoader(false));
    //         setQuestions(result.default_questions && result.default_questions)
    //         setInputFile1Base(result?.logos_urls?.logo_home_page)
    //         setInputFile2Base(result?.logos_urls?.logo_side_img)
    //     } catch (error) {
    //         toast.error(error as ToastContent<unknown>)
    //         dispatch(handleLoader(false));
    //     }
    // }

    // const getErrorMessage = (errorKey: string): string => {
    //     const nestedKeys = errorKey.split('.');
    //     let currentError: any = errors;

    //     for (const key of nestedKeys) {
    //         if (currentError && typeof currentError === 'object' && key in currentError) {
    //             currentError = currentError[key];
    //         } else {
    //             return '';
    //         }
    //     }
    //     return currentError?.message || '';
    // };


    const getVersions = async () => {
        dispatch(handleLoader(true));
        try {
            const { result, error } = await getClientVersions(localStorage.getItem("clientName"))
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            const reverseArray = result.reverse().filter((i: string) => i !== null).map((i: any) => { return { name: i } });
            setVersionOptions(reverseArray)
            dispatch(handleLoader(false));
            toast.success(result?.message, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        } catch (error: any) {
            dispatch(handleLoader(false))
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }


    const getBase64 = (file: any) => {
        return new Promise<string>(async (resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.onload = async () => {
                const base64Data = fileReader.result as string;
                try {
                    const modifiedBase64Data = await manipulateBase64Data(base64Data);
                    resolve(modifiedBase64Data);
                } catch (error) {
                    reject(error);
                }
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
            fileReader.readAsDataURL(file);
        });
    };

    const manipulateBase64Data = async (base64Data: string): Promise<string> => {
        return new Promise<string>((resolve, reject) => {
            const base64Index = base64Data.indexOf('base64');
            if (base64Index !== -1) {
                resolve(base64Data?.slice(base64Index + 7));
            } else {
                resolve(base64Data);
            }
        });
    };

    const isBase64 = (data: any): Promise<boolean> => {
        return new Promise<boolean>((resolve) => {
            const base64Pattern = /^data:(.+);base64,(.*)$/;
            resolve(base64Pattern.test(data));
        });
    };

    const fileChange = async (file: any, type: string) => {
        try {
            const isBase64Confirm = await isBase64(file); // Check if the file is already base64
            if (isBase64Confirm) {
                if (type === 'logo_home_page') {
                    setInputFile1Base(file);
                } else if (type === 'logo_side_img') {
                    setInputFile2Base(file);
                }
            } else {
                const base64Data = await getBase64(file);
                if (type === 'logo_home_page') {
                    setInputFile1Base(base64Data);
                } else if (type === 'logo_side_img') {
                    setInputFile2Base(base64Data);
                }
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };


    function isFloat(n: any) {
        return n !== Math.floor(n);
    }

    const onSubmit = async (data: { [x: string]: any }) => {
        dispatch(handleLoader(true));
        setTextValue("")
        const finalArrayOfQuestion = questions.filter((a: string) => a !== '');
        setQuestions(finalArrayOfQuestion);
        console.log("finalArrayOfQuestion", finalArrayOfQuestion)
        // const default_questions = Object.values(data.default_questions);

        const logos_urls = {
            logo_home_page: inputFile1Base,
            logo_side_img: inputFile2Base,
        }

        const postgres_credentials = {
            host_port: data.postgres_credentials.host_port,
            user_name: data.postgres_credentials.user_name,
            password: data.postgres_credentials.password,
            db_name: data.postgres_credentials.db_name
        }

        const keycloak_credentials = {
            client_id: data.keycloak_credentials.client_id,
            client_secret: data.keycloak_credentials.client_secret,
            base_url: data.keycloak_credentials.base_url,
            realm_name: data.keycloak_credentials.realm_name
        }

        const mongodb_credentials = {
            host_port: data.mongodb_credentials.host_port,
            user_name: data.mongodb_credentials.user_name,
            password: data.mongodb_credentials.password,
            db_name: data.mongodb_credentials.db_name,
            connection_name: data.mongodb_credentials.connection_name,
        }

        const ai_ml_apis = {
            base_url_ron: data.ai_ml_api.base_url_ron,
            base_url_gpt: data.ai_ml_api.base_url_gpt,
            base_url_file_processing: data.ai_ml_api.base_url_file_processing,
        }

        const email_configurations = {
            smtp_server: data.email_configuration.smtp_server,
            smtp_port: data.email_configuration.smtp_port,
            smtp_username: data.email_configuration.smtp_username,
            smtp_password: data.email_configuration.smtp_password,
        }

        const voice_params = {
            max_new_tokens: data.voice_params.max_new_tokens.name,
            chunk_length_s: data.voice_params.chunk_length_s.name,
            batch_size: data.voice_params.batch_size.name
        }
        const lama_model_name = {
            model_name_or_path: data.lama_model_name.model_name_or_path,
            // model_basename: data.lama_model_name.model_basename
        }

        const pdf_documents = {
            chunk_size: data.pdf_documents.chunk_size.name,
            chunk_overlap: data.pdf_documents.chunk_overlap.name
        }

        const embedding_model_name = {
            embedding_model_name: data.embedding_model_name.embedding_model_name
        }

        const faiss_vactor_db = {
            ron_main_vector_db_directory: data.faiss_vactor_db.ron_main_vector_db_directory,
            user_temp_folder: data.faiss_vactor_db.user_temp_folder,
            source_info_threshold: data.faiss_vactor_db.source_info_threshold
        }

        const lama_model_conf = {
            max_token: data.lama_model_conf.max_token.name,
            temperature: data.lama_model_conf.temperature,
            // n_gpu_layers: data.lama_model_conf.n_gpu_layers.toString(),
            // n_batch: data.lama_model_conf.n_batch.toString(),
            // n_ctx: data.lama_model_conf.n_ctx.toString(),
            streaming: data.lama_model_conf.streaming.name === "True" ? true : data.lama_model_conf.streaming.name === "False" ? false : null
        }

        const actual_pdf = {
            actual_pdf_base_url: data.actual_pdf.actual_pdf_base_url
        }

        const RON_lama_system_prompt = {
            default_system_prompt: data.RON_lama_system_prompt.default_system_prompt,
            prompt_document_training: data.RON_lama_system_prompt.prompt_document_training,
            prompttemplatetextsummerization: data.RON_lama_system_prompt.prompttemplatetextsummerization,
            ner_prompt: data.RON_lama_system_prompt.ner_prompt,
            prompttemplateclassification: data.RON_lama_system_prompt.prompttemplateclassification
        }

        const generation_param = {
            inference_server_url: data.generation_param.inference_server_url,
            max_new_tokens: data.generation_param.max_new_tokens.name,
            temperature: data.generation_param.temperature,
            default_email_template: data.generation_param.default_email_template,
            default_post_template: data.generation_param.default_post_template,
            default_product_template: data.generation_param.default_product_template,
            default_regenerate_product_template: data.generation_param.default_regenerate_product_template,
            default_article_template: data.generation_param.default_article_template,
            default_idea_template: data.generation_param.default_idea_template
        }

        const butter_pie_configuration = {
            content_strategy: data?.butter_pie_configuration.content_strategy,
            content_production: data?.butter_pie_configuration.content_production,
            audience_growth: data?.butter_pie_configuration.audience_growth,
            monetization: data?.butter_pie_configuration.monetization,
            marketing_seo: data?.butter_pie_configuration.marketing_seo,
            legal_ethical: data?.butter_pie_configuration.legal_ethical,
            mindset_productivity: data?.butter_pie_configuration.mindset_productivity,
            networking: data?.butter_pie_configuration.networking,
            general_prompt: data?.butter_pie_configuration.general_prompt,
            api_key: decryptPassword(data?.butter_pie_configuration.api_key),
        }

        const ai_chatbot = {
            ai_client_name: "RON_Gpt",
            temperature: data.ai_chatbot.temperature,
            max_token: data.ai_chatbot.max_token.name,
            log_url: data.ai_chatbot.log_url,
            main_category: data.ai_chatbot.main_category,
            bundling_on_column_name: data.ai_chatbot.bundling_on_column_name,
            category_style_idea: data.ai_chatbot.category_style_idea?.split(","),
            max_pdf_size: data.ai_chatbot.max_pdf_size.name,
            max_zip_size: data.ai_chatbot.max_zip_size.name,
            primary_column: data.ai_chatbot.primary_column,
            product_details: data.ai_chatbot.product_details,
            sub_category: data.ai_chatbot.sub_category,
            source_name: data.ai_chatbot.source_name,
            // system_prompt: data.ai_chatbot.system_prompt
        }

        const TGI_llama_inference_url = {
            inference_server_url_local: data.TGI_llama_inference_url.inference_server_url_local
        }
        const Metadata = {
            version: data.Metadata.version
        }


        const body = {
            client_name: data.client_name,
            file_size: data.file_size,
            log_source: data.log_source.name,
            suggestion_text: "suggestion text",
            default_questions: finalArrayOfQuestion,
            default_label: data.default_label,
            logos_urls: logos_urls,
            postgres_credentials,
            keycloak_credentials,
            mongodb_credentials,
            ai_ml_apis,
            voice_params,
            email_configurations,
            lama_model_name,
            pdf_documents,
            generation_param,
            butter_pie_configuration,
            embedding_model_name,
            faiss_vactor_db,
            lama_model_conf,
            ai_chatbot,
            actual_pdf,
            RON_lama_system_prompt,
            TGI_llama_inference_url,
            Metadata,
            is_ai_mi_update: isBackendDataChanged,
            is_voice_params_update: isVoiceDataChanged,
            is_ai_chatbot_update: isChatBotDataChanged,
            is_generation_update: isGenerationDataChanged,
            is_butter_pie_admin_update: isButterPieChanged,
            created_by: localStorage.getItem('username')
        };


        try {
            const { result, error } = await addParamsConfig(body)
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            dispatch(handleLoader(false));
            toast.success(result?.message, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        } catch (error: any) {
            dispatch(handleLoader(false))
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    const onerror = (data: any) => {
        const errorMessages: { [key: string]: string } = {};
        Object.keys(data).forEach((key) => {
            const error = data[key];

            if (typeof error === 'object' && error !== null) {
                // If it's an object, recursively call the function for nested errors
                Object.keys(error).forEach((nestedKey) => {
                    const nestedValue = error[nestedKey].message;
                    errorMessages[nestedKey] = nestedValue;
                });
            } else {
                errorMessages[key] = error.message;
            }
        })
        const errorMessageString = Object.entries(errorMessages)
            .map(([key, value]) => `${key}: ${value}`)
            .join('\n');

        errorMessageString && toast.error('Please fill mandatory fields', {
            style: {
                backgroundColor: '#F1F1F1', // Grey background
            }
        });
    }

    // useEffect(() => {
    //     if (envParam) {
    //         getFieldData("krishna")
    //     } else {
    //         getFieldData("krishna")
    //     }
    // }, [envParam]);

    useEffect(() => {
        getVersions();
    }, [])

    const defaultFunc = async () => {
        setClientVersion({ name: "" });
        await getFieldData(localStorage.getItem("clientName"))
    }

    return (
        <div className='content-wrapper p-4'>
            <div className="user-group user-management-section">
                <FormProvider {...form}>
                    <form onSubmit={form.handleSubmit(onSubmit, onerror)}>
                        <div className='d-flex align-items-center justify-content-between mb-3 table-top-row'>
                            <h4 className='mb-0'>Parameter Configuration</h4>
                            <div className='d-flex align-items-center table-right-row'>
                                <div className="d-flex align-items-center table-right-first">
                                    <div className="d-flex align-items-center table-search mr-3 mt-1 mb-1">
                                        <Dropdown
                                            onChange={(e) => {
                                                setClientVersion(e.target.value)
                                                // getFieldDataByVersion(e.target.value)
                                            }}
                                            optionLabel="name"
                                            options={versionOptions}
                                            value={clientVersion}
                                            placeholder="View Previous Version"
                                            className={`outline-select`}
                                            style={{ width: "200px", maxWidth: "100%" }}
                                        />
                                        {clientVersion.name !== "" &&
                                            <span className='refresh-btn ml-3'><i className="fa fa-refresh" onClick={defaultFunc} style={{ cursor: "pointer" }}></i></span>
                                        }
                                    </div>
                                </div>
                                {clientVersion.name === "" && <>
                                    <div className="table-right-end mt-1 mb-1">
                                        <button className="outline-active-btn" type="submit">Save</button>
                                    </div>
                                    {/* <button className="btn btn-outline-dark btn-sm px-3 mt-3 mt-sm-0" type="button">Clear</button> */}
                                </>}
                            </div>
                        </div>
                        <div className="user-group-card">
                            <div className="user-group-body">
                                <div className="tabs-wrap">
                                    <TabView>
                                        <TabPanel header="FRONT END">
                                            <FrontEndParameter
                                                clientVersion={clientVersion.name}
                                                methods={form}
                                                questions={questions}
                                                setQuestions={setQuestions}
                                                inputFile1={inputFile1}
                                                inputFile2={inputFile2}
                                                setInputFile1={setInputFile1}
                                                setInputFile2={setInputFile2}
                                                fieldData={fieldData}
                                                fileChange={fileChange}
                                                setInputFile1Base={setInputFile1Base}
                                                setInputFile2Base={setInputFile2Base}
                                                inputFile1Base={inputFile1Base}
                                                inputFile2Base={inputFile2Base}
                                            />
                                        </TabPanel>
                                        <TabPanel header="MIDDLE LAYER">
                                            <MiddleLayerParameter clientVersion={clientVersion.name} methods={form} fieldData={fieldData} />
                                        </TabPanel>
                                        <TabPanel header="BACK END">
                                            <BackendLayer
                                                clientVersion={clientVersion.name}
                                                methods={form}
                                                fieldData={fieldData}
                                                isBackendDataChanged={isBackendDataChanged}
                                                setIsBackendDataChanged={setIsBackendDataChanged}
                                                handelPrompt={handelPrompt}
                                                textValue={textValue}
                                                setTextValue={setTextValue}
                                            />
                                        </TabPanel>
                                        <TabPanel header="BOT">
                                            <ChatBotParams
                                                clientVersion={clientVersion.name}
                                                methods={form}
                                                fieldData={fieldData}
                                                isChatBotDataChanged={isChatBotDataChanged}
                                                setIsChatBotDataChanged={setIsChatBotDataChanged}
                                                handelPrompt={handelPrompt}
                                            />
                                        </TabPanel>
                                        <TabPanel header="VOICE">
                                            <VoiceParamsLayer
                                                clientVersion={clientVersion.name}
                                                methods={form}
                                                fieldData={fieldData}
                                                isVoiceDataChanged={isVoiceDataChanged}
                                                setIsVoiceDataChanged={setIsVoiceDataChanged}
                                                handelPrompt={handelPrompt}
                                            />
                                        </TabPanel>
                                        <TabPanel header="GENERATION">
                                            <GenerationParams
                                                clientVersion={clientVersion.name}
                                                methods={form}
                                                fieldData={fieldData}
                                                isGenerationDataChanged={isGenerationDataChanged}
                                                setIsGenerationChanged={setIsGenerationChanged}
                                                handelPrompt={handelPrompt}
                                                textValue={textValue}
                                                setTextValue={setTextValue}
                                            />
                                        </TabPanel>
                                        {/* <TabPanel header="CREATORMATE">
                                            <ButterPieParams
                                                clientVersion={clientVersion.name}
                                                methods={form}
                                                fieldData={fieldData}
                                                isButterPieChanged={isButterPieChanged}
                                                setIsButterPieChanged={setIsButterPieChanged}
                                                handelPrompt={handelPrompt}
                                            />
                                        </TabPanel> */}
                                    </TabView>
                                </div>
                            </div>
                        </div>
                    </form>
                </FormProvider>
                <ParamsPopUp content={"pop-up"} />
            </div>
        </div>
    );
}

export default AddUpdateConfiguration;
